<!-- 学籍异动列表 -->
<template>
    <div class="el-stuStatusChangeApply">
        <el-row class="page_content">
            <h1 class="head_title">学籍异动</h1>
            <!-- <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="是否填写">
                    <el-select v-model="form.teaEvaluateStudentStatus" :filterable="true" @change="selectScore" placeholder="请选择学期">
                        <el-option label="所有" value=""></el-option>
                        <el-option label="已填写" value="1"></el-option>
                        <el-option label="未填写" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否填写">

                </el-form-item>
            </el-form> -->
            <div style="margin-bottom: 10px;">
                <el-button type="primary" icon="el-icon-plus" @click="addStuStatusChange">申请学籍异动</el-button>
            </div>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="afterState" header-align="center" align="center" width="180" label="异动类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.afterState == '1'">在籍</span>
                        <span v-if="scope.row.afterState == '1_2'">转专业</span>
                        <span v-if="scope.row.afterState == '1_3'">转函授站</span>
                        <span v-if="scope.row.afterState == '1_4'">转班级</span>
                        <span v-if="scope.row.afterState == '1_5'">复学</span>
                        <span v-if="scope.row.afterState == '1_6'">留级</span>
                        <span v-if="scope.row.afterState == '2'">休学</span>
                        <span v-if="scope.row.afterState == '3'">未报到</span>
                        <span v-if="scope.row.afterState == '4'">主动退学</span>
                        <span v-if="scope.row.afterState == '5'">勒令退学</span>
                        <span v-if="scope.row.afterState == '6'">取消学籍</span>
                        <span v-if="scope.row.afterState == '7'">已毕业</span>
                    </template>
                </el-table-column>
                <el-table-column prop="corSchoolName" header-align="center" align="center" width="180" label="异动后函授站">
                    <template slot-scope="scope">{{scope.row.corSchoolName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="professionalName" header-align="center" align="center" width="180" label="异动后专业">
                    <template slot-scope="scope">{{scope.row.professionalName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="schoolClassName" header-align="center" align="center" width="180" label="异动后班级">
                    <template slot-scope="scope">{{scope.row.schoolClassName || '-'}}</template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="center" width="180" label="申请时间">
                </el-table-column>
                <el-table-column prop="auditStatus" header-align="center" align="center" width="180" label="审核状态">
                    <template slot-scope="scope">
                        <!-- 1通过2审核中3不通过 -->
                        <template v-if="scope.row.auditStatus == 1"><span style="color: #409EFF;">通过</span></template>
                        <template v-if="scope.row.auditStatus == 2"><span style="color: rgb(147 144 144);">审核中</span></template>
                        <template v-if="scope.row.auditStatus == 3"><span style="color: red;">不通过</span></template>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" header-align="center" align="center" label="审核结果备注">
                    <template slot-scope="scope">
                        <div v-html="scope.row.remark"></div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block" style="text-align: center;position: absolute;bottom: 0;width: 96%;margin-bottom: 20px;">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1" :page-size="limit" :hide-on-single-page="true"
                    layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-row>

        <!-- 申请学籍异动对话框 -->
        <el-dialog title="申请学籍异动" :visible.sync="dialogVisible" @close="closeDialog" width="800px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <el-form-item label="异动类型" prop="afterState">
                    <!-- 申请之后：学籍状态(1在籍 1_2转专业 1_3转函授站 1_4转班级 1_5复学 1_6留级 2休学 3未报到 4主动退学 5勒令退学 6取消学籍 7已毕业) -->
                    <el-select v-model="ruleForm.afterState" placeholder="请选择异动类型" @change="changeAfterState" style="width: 400px;">
                        <!-- <el-option label="在籍" value="1"></el-option> -->
                        <el-option label="转专业" value="1_2"></el-option>
                        <el-option label="转函授站" value="1_3"></el-option>
                        <el-option label="转班级" value="1_4"></el-option>
                        <!-- <el-option label="复学" value="1_5"></el-option> -->
                        <!-- <el-option label="留级" value="1_6"></el-option> -->
                        <el-option label="休学" value="2"></el-option>
                        <!-- <el-option label="未报到" value="3"></el-option> -->
                        <el-option label="退学" value="4"></el-option>
                        <!-- <el-option label="勒令退学" value="5"></el-option> -->
                        <!-- <el-option label="取消学籍" value="6"></el-option>
                        <el-option label="已毕业" value="7"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item label="转专业" v-if="ruleForm.afterState == '1_2'" prop="professionalId">
                    <el-select v-model="ruleForm.professionalId" placeholder="请选择专业" style="width: 400px;" >
                        <el-option v-for="(item, index) in professionalList" :key="index+'professionalList'" :label="item.allProfessionalName" :value="item.professionalId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转函授站" v-if="ruleForm.afterState == '1_3'" prop="corSchoolId">
                    <el-select v-model="ruleForm.corSchoolId" placeholder="请选择函授站" style="width: 400px;">
                        <el-option v-for="(item, index) in correspondenceSchoolList" :key="index+'correspondenceSchoolList'" :label="item.corSchoolName" :value="item.corSchoolId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转班级" v-if="ruleForm.afterState == '1_4'" prop="schoolClassId">
                    <el-select v-model="ruleForm.schoolClassId" placeholder="请选择班级" style="width: 400px;">
                        <el-option v-for="(item, index) in schoolClassList" :key="index+'schoolClassList'" :label="item.schoolClassName" :value="item.schoolClassId"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 异动说明 -->
                <el-form-item label="异动说明" v-if="statusChangeInfo.info" style="margin-bottom: 0;">
                    <div style="white-space: pre-wrap; color: #606266; padding: 10px; background-color: #f5f7fa; border-radius: 4px;" v-html="statusChangeInfo.info"></div>
                    <div v-if="statusChangeInfo.fileUrls" style="margin-top: 10px;">
                        <div v-for="(fileUrl, index) in statusChangeInfo.fileUrlList" :key="index" style="margin-top: 5px;">
                            <el-link type="primary" :underline="false" @click="downloadFile(fileUrl)">
                                <i class="el-icon-document"></i> 附件{{ index + 1 }} 点击下载
                            </el-link>
                        </div>
                    </div>

                </el-form-item>
                <el-form-item label="" style="margin-bottom: 0;">
                    <div v-if="statusChangeInfo.linkTemplateId && statusChangeInfo.linkTemplateName" style="margin-top: 10px;">
                        <el-button type="primary" size="small" @click="openFillDataDialog">
                            <i class="el-icon-edit"></i> 填写{{statusChangeInfo.linkTemplateName}}
                        </el-button>
                    </div>
                </el-form-item>
                <!-- 文件上传 -->
                <el-form-item label="附件上传">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="headers"
                        :on-success="handleUploadSuccess"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                        multiple>
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">支持多文件上传</div> -->
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitInfo" :loading="submitBut">立即申请</el-button>
            </span>
        </el-dialog>

        <!-- 填写数据对话框 -->
        <linkTemplateEdit
            v-if="fillDataDialogVisible && statusChangeInfo.linkTemplateId"
            :templateId="statusChangeInfo.linkTemplateId"
            :templateName="statusChangeInfo.linkTemplateName"
            ref="childComponent"
            :toolShow="true"
            @onClosedialog="fillDataDialogVisible = false;"
            :dialogShow="fillDataDialogVisible"
            :showInfo="{
                edit: true,
                print: false,
                down: false,
                save: true
            }">
        </linkTemplateEdit>
        <!-- <el-dialog title="填写数据" :visible.sync="fillDataDialogVisible" width="80%" :close-on-click-modal="false" @close="closeFillDataDialog">
            <div style="height: 60vh;overflow: auto;">
                <linkTemplateEdit
                    v-if="fillDataDialogVisible && statusChangeInfo.linkTemplateId"
                    :templateId="statusChangeInfo.linkTemplateId"
                    :templateName="statusChangeInfo.linkTemplateName"
                    ref="childComponent"
                    :toolShow="true"
                    :showInfo="{
                        edit: true,
                        print: false,
                        down: false,
                        save: true
                    }">
                </linkTemplateEdit>
            </div>
            <div slot="footer" class="dialog-footer">
                  <el-button @click="fillDataDialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="saveData">确定</el-button>
                </div>
        </el-dialog> -->
    </div>
</template>
<script>
    import { getStorageKeyForRoleTag,getCookieForRoleTag } from '../../common/ulit';
    import linkTemplateEdit from '../../components/linkTemplateEdit.vue';
    export default {
        name: "StuStatusChangeApply",
        components: {
            linkTemplateEdit
        },
        data() {
            return {
                form: {
                    teaEvaluateStudentStatus: ""
                },
                ruleForm: {
                    afterState: '',
                    professionalId: '',
                    corSchoolId: '',
                    schoolClassId: "",
                    approveFileUrls: '', // 附件路径，逗号分隔
                },
                uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
                headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
                fileList: [], // 上传文件列表
                statusChangeInfo: { // 异动说明信息
                    info: '',
                    fileUrls: '',
                    fileUrlList: [],
                    linkTemplateId: '',
                    linkTemplateName: ''
                },
                rules: {
                    afterState: [{
                        required: true,
                        message: '请选择异动类型',
                        trigger: 'change'
                    }],
                    professionalId: [{
                        required: true,
                        message: '请选择专业',
                        trigger: 'change'
                    }],
                    corSchoolId: [{
                        required: true,
                        message: '请选择函授站',
                        trigger: 'change'
                    }],
                    schoolClassId: [{
                        required: true,
                        message: '请选择班级',
                        trigger: 'change'
                    }],
                },
                tableData: [],
                submitBut: false,
                currentPage1: 1,
                total: 0,
                limit: 6,
                page: 1,
                dialogVisible: false,
                professionalList:[], //专业List
                correspondenceSchoolList:[], //函授站List
                schoolClassList:[],//班级List
                studentInfo:{},
                fillDataDialogVisible: false, // 填写数据对话框显示状态
            };
        },
        created() {
            this.getSurveyList();
            this.getPersonalInfo();
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.limit = val;
                this.getSurveyList();
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page = val;
                this.getSurveyList();
            },
            getSurveyList() { //获取List
                let param = this.form;
                param.limit = this.limit;
                param.page = this.page;
                this.$store.dispatch("user/getStudentChangeRecordList", this.form).then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.tableData = ret.data;
                        this.total = ret.count;
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            getPersonalInfo(){
                this.$store.dispatch("user/getPersonalInfo").then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.studentInfo = ret.data || {};
                    } else {
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                });
            },
            changeAfterState(e){ //异动类型变更
                // 获取异动说明
                if(e) {
                    this.getStatusChangeInfo(e);
                }

                if(e == '1_2'){ //转专业
                    if(this.professionalList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getProfessionalValues",{professionalStatus:1,grade:this.studentInfo.grade}).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.professionalList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else if(e == '1_3'){ //转函授站
                    if(this.correspondenceSchoolList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getCorrespondenceSchoolValues",{corSchoolStatus:1,grade:this.studentInfo.grade}).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.correspondenceSchoolList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else if(e == '1_4'){ //转班级
                    if(this.schoolClassList.length > 0){
                        return;
                    }
                    this.$store.dispatch("user/getSchoolClassValues",{
                            schoolClassStatus:1,
                            grade:this.studentInfo.grade,
                            professionalId:this.studentInfo.professionalId,
                            corSchoolId:this.studentInfo.corSchoolId,
                        }).then((ret) => {
                        if (ret.code === 0 || ret.code === '0') {
                            this.schoolClassList = ret.data || [];
                        } else {
                            this.$message({
                                message: ret.msg,
                                type: 'warning'
                            });
                        }
                    });
                }else{
                    this.ruleForm.professionalId = "";
                    this.ruleForm.corSchoolId = "";
                    this.ruleForm.schoolClassId = "";
                }
            },
            getStatusChangeInfo(statusState) { // 获取异动说明
                this.$store.dispatch("user/getStatusChangeInfo", { statusState: statusState }).then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.statusChangeInfo = {
                            info: ret.data.info || '',
                            fileUrls: ret.data.fileUrls || '',
                            fileUrlList: ret.data.fileUrls ? ret.data.fileUrls.split(',').filter(url => url.trim()) : [],
                            linkTemplateId: ret.data.linkTemplateId || '',
                            linkTemplateName: ret.data.linkTemplateName || ''
                        };
                    } else {
                        this.statusChangeInfo = {
                            info: '',
                            fileUrls: '',
                            fileUrlList: [],
                            linkTemplateId: '',
                            linkTemplateName: ''
                        };
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                    }
                }).catch(() => {
                    this.statusChangeInfo = {
                        info: '',
                        fileUrls: '',
                        fileUrlList: [],
                        linkTemplateId: '',
                        linkTemplateName: ''
                    };
                });
            },
            handleUploadSuccess(res, file) { // 文件上传成功
                if (res.code === 0 || res.code === '0') {
                    const fileUrl = res.data.url;
                    const fileName = res.data.nameFormat || file.name;
                    // 将文件URL添加到列表中
                    if (!this.ruleForm.approveFileUrls) {
                        this.ruleForm.approveFileUrls = fileUrl;
                    } else {
                        this.ruleForm.approveFileUrls += ',' + fileUrl;
                    }
                    // 更新文件列表显示
                    if (!this.fileList) {
                        this.fileList = [];
                    }
                    this.fileList.push({
                        name: fileName,
                        url: fileUrl,
                        response: res
                    });
                    this.$message.success('文件上传成功');
                } else {
                    this.$message.error(res.msg || '文件上传失败');
                }
            },
            handleRemove(file, fileList) { // 移除文件
                // 从 approveFileUrls 中移除对应的URL
                let urlToRemove = '';
                if (file.response && file.response.data) {
                    urlToRemove = file.response.data.url;
                } else if (file.url) {
                    urlToRemove = file.url;
                }
                if (urlToRemove && this.ruleForm.approveFileUrls) {
                    const urlArray = this.ruleForm.approveFileUrls.split(',');
                    const newUrlArray = urlArray.filter(url => url.trim() !== urlToRemove.trim());
                    this.ruleForm.approveFileUrls = newUrlArray.join(',');
                }
                this.fileList = fileList;
            },
            beforeUpload(file) { // 上传前校验
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('上传文件大小不能超过 50MB!');
                    return false;
                }
                return true;
            },
            downloadFile(fileUrl) { // 下载文件
                if (!fileUrl) {
                    this.$message.warning('文件地址为空');
                    return;
                }
                const prefix = window.configs.API_ROOT;
                const fullUrl = prefix + fileUrl;
                const a = document.createElement("a");
                fetch(fullUrl)
                    .then((res) => res.blob())
                    .then((blob) => {
                        a.href = URL.createObjectURL(blob);
                        // 从URL中提取文件名
                        let fileName = fileUrl.split('\\');
                        if(fileName != null && fileName != '' && fileName.length > 0){
                            fileName = fileName[fileName.length - 1];
                        }
                        a.download = fileName  || '附件';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch(() => {
                        this.$message.error('文件下载失败');
                    });
            },
            selectScore(v) {
                this.getSurveyList();
            },
            addStuStatusChange() {
                this.dialogVisible = true;
            },
            closeDialog(){ //关闭对话框时执行
                this.$refs['ruleForm'].resetFields();
                this.fileList = [];
                this.ruleForm.approveFileUrls = '';
                this.statusChangeInfo = {
                    info: '',
                    fileUrls: '',
                    fileUrlList: [],
                    linkTemplateId: '',
                    linkTemplateName: ''
                };
            },
            openFillDataDialog() { // 打开填写数据对话框
                if (!this.statusChangeInfo.linkTemplateId || !this.statusChangeInfo.linkTemplateName) {
                    this.$message.warning('模板信息缺失');
                    return;
                }
                this.fillDataDialogVisible = true;
            },
            closeFillDataDialog() { // 关闭填写数据对话框
                this.fillDataDialogVisible = false;
            },
            submitInfo() { //提交数据
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确定提交，提交后将无法进行修改?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });

                            const cachedDataStr = sessionStorage.getItem(getStorageKeyForRoleTag('template_' + this.statusChangeInfo.linkTemplateId));
                            if(cachedDataStr) {
                                this.ruleForm.attributeRelationList = JSON.parse(cachedDataStr).attributeRelationList;
                            }

                            this.$store.dispatch("user/applyStatusChange", this.ruleForm).then((ret) => {
                                loading.close();
                                if (ret.code === 0 || ret.code === '0') {
                                    this.$message.success("保存成功！");
                                    this.getSurveyList();
                                    this.dialogVisible = false;
                                } else {
                                    this.$message({
                                        message: ret.msg,
                                        type: 'warning'
                                    });
                                }
                            }).catch((error) => {
                                // this.$message({
                                //     message: "接口请求失败！",
                                //     type: 'warning'
                                // });
                                loading.close();
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消提交'
                            });
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            saveData(){
                this.$refs.childComponent.saveAllData();
            }
        }
    };
</script>
<style lang="less">
    @import '../../styles/base.less';

    .el-stuStatusChangeApply {
        .wd {
            color: @red;
        }

        .el-dialog__body {
            border-top: 1px solid #ebeef5;
        }

        .el-descriptions-item__container {
            font-size: 17px;
        }

        .el-descriptions-item__label {
            white-space: nowrap;
            width: 140px;
            text-align: right;
        }

        .el-descriptions-item__content {
            max-height: 200px;
            overflow: auto;
        }

        .teacherEvaluateInfoClass {
            .el-table .el-table__cell {
                padding: 5px 0;
            }
        }

        .teaEvaluateDesc {
            p {
                margin: 5px 0;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/statusChange/stuStatusChangeApply.vue